module.exports = __webpack_public_path__ + "static/media/dj.053564f4.svg";